import React from 'react';

export default class MoneyDisplay extends React.Component {

  constructor(props) {
    super(props);
  }

  
  // pushes 0-3 images into an array to display as problem to solve
  // number : this.props.gameState coin type
  // width and height : (1/2 of the @2X size) must be strings when called, ex. "78"
  // source : path to the coin image
  createImageArray(number, width, height, source) {
    var imgArray = [];
      for(var i = 0; i < number; i++) 
        imgArray.push(<img key={i} width={width} height={height} src={source} />);
      return imgArray;
  }

  render() {
    var pennyUrl = '/assets/vt-aplusmath/images/money/lincoln-penny@2X.png';
    var nickelUrl = '/assets/vt-aplusmath/images/money/jefferson-nickel-new@2X.png';
    var dimeUrl = '/assets/vt-aplusmath/images/money/roosevelt-dime@2X.png';
    var quarterUrl = '/assets/vt-aplusmath/images/money/washington-quarter@2X.png';
    var dollarUrl = '/assets/vt-aplusmath/images/money/dollar@2X.png';
    
    return (
      <div className="money-shown">
        <div>
          {this.createImageArray(this.props.gameState.dollars, '252', '110', dollarUrl )}
        </div>
        
        <div className="money-shown__coins">
          {this.createImageArray(this.props.gameState.quarters, '84', '84', quarterUrl)}
        </div>
        
        <div className="money-shown__coins">
          {this.createImageArray(this.props.gameState.dimes, '64', '64', dimeUrl)}
        </div>
        
        <div className="money-shown__coins">
          {this.createImageArray(this.props.gameState.nickels, '75', '75', nickelUrl)}
        </div>
        
      
        <div className="money-shown__coins">
          {this.createImageArray(this.props.gameState.pennies, '67', '67', pennyUrl)}
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/money/money-display.js
 **/